'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import tinymce from 'tinymce';
import { pick } from 'rich-text-lib/utils/iterables';
import { Alignments } from 'rich-text-lib/constants/alignments';
import TinyMceAlignMenu from '../components/toolbar/TinyMceAlignMenu';
import { CANVAS_ALIGNMENT } from '../constants/toolbar';
import { AlignmentCommandMap } from '../constants/hsformatting';
import { jsx as _jsx } from "react/jsx-runtime";
const alignments = pick(['LEFT', 'CENTER', 'RIGHT', 'JUSTIFY'], Alignments);
const getAlignmentChangeHandler = editor => value => {
  editor.execCommand(AlignmentCommandMap[value]);
};
const createAlignFormatChangeHandler = (editor, formats) => {
  editor.formatter.formatChanged(formats.join(','), (isActive, {
    format
  }) => {
    editor.fire(`FormatChanged:${format}`, {
      isActive,
      format
    });
  });
};
export function addAlignmentControls(editor) {
  let lastAlign = alignments.LEFT;
  const formats = Object.keys(alignments).map(key => `align${alignments[key]}`);
  if (editor.formatter) {
    createAlignFormatChangeHandler(editor, formats, lastAlign);
  } else {
    editor.on('init', () => {
      createAlignFormatChangeHandler(editor, formats, lastAlign);
    });
  }
  tinymce.canvas.addButton(editor, CANVAS_ALIGNMENT, {
    renderControl: props => {
      const rest = _objectWithoutPropertiesLoose(props, _excluded);
      return /*#__PURE__*/_jsx(TinyMceAlignMenu, Object.assign({
        "data-test-id": CANVAS_ALIGNMENT,
        editor: editor,
        formats: formats,
        dropdownClassName: "mce-hubspot-menu",
        onChange: getAlignmentChangeHandler(editor),
        getlastAlign: () => lastAlign,
        setlastAlign: align => lastAlign = align,
        defaultAlignment: alignments.LEFT,
        alignOptions: alignments
      }, rest));
    }
  });
}